import React from 'react';
const Localization = React.createContext({});
export default Localization;